import { ROWS_PER_PAGE } from "app/pages/industry-analysis/market-builder/tabs/common/utils";
import type { FC } from "react";
import type { setter } from "app/UtilitiesAndConstants/types/setter";
import { Pagination, PaginationInput } from "@similarweb/ui-components";
import { colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";

interface ITableFooter {
    page: number;
    totalRecords: number;
    setPage: setter<ITableFooter["page"]>;
}

const { carbon } = colorsPalettes;

const Container = styled.div`
    border-top: 1px solid ${carbon[100]};
    display: flex;
    justify-content: flex-end;
    padding: 12px;
`;

export const TableFooter: FC<ITableFooter> = (props) => {
    const { page, totalRecords, setPage } = props;
    return (
        <Container>
            <Pagination
                page={page}
                itemsPerPage={ROWS_PER_PAGE}
                itemsCount={totalRecords}
                handlePageChange={setPage}
                captionElement={PaginationInput}
                hasItemsPerPageSelect={false}
                captionPosition={"center"}
            />
        </Container>
    );
};
